/**
 * biasReviewLog.js
 * --------------------------------------------------------------------------
 * EU AI Act Article 10 (Data Governance) compliance artifact.
 *
 * Article 10 requires high-risk AI systems to use training and reference
 * data that is "relevant, sufficiently representative, and to the best
 * extent possible, free of errors and complete in view of the intended
 * purpose." The skill ontology that powers ClearEqual's profile matching
 * is reference data in this sense, biased terms in the ontology would
 * propagate bias into every match decision.
 *
 * This file is the audit trail of every review of the skill ontology for
 * gender-coded language, culturally-coded language, and language that has
 * historically caused indirect discrimination in resume parsing tools.
 *
 * Reviews are performed quarterly and on every ontology change of more
 * than 10% of nodes. The reviewer is recorded so accountability can be
 * traced under Art. 14 (Human Oversight).
 *
 * REGULATORY REFERENCE:
 *   - EU AI Act, Regulation (EU) 2024/1689, in force from 2 August 2024
 *   - Art. 10 (Data and data governance)
 *   - Annex III §4(b) (high-risk classification for employment AI)
 */

export const BIAS_REVIEW_LOG = [
  {
    id: 'br-2026-q1',
    reviewDate: '2026-01-15',
    reviewerName: 'Christoph Both',
    reviewerRoleKey: 'biasReview.reviewerRole.cofounderLawyerDe',
    scopeKey:    'biasReview.q1_2026.scope',
    findingKeys: [
      'biasReview.q1_2026.finding1',
      'biasReview.q1_2026.finding2',
      'biasReview.q1_2026.finding3',
      'biasReview.q1_2026.finding4',
    ],
    actionsKey:  'biasReview.q1_2026.actions',
    nextReviewDue: '2026-04-15',
  },
  {
    id: 'br-2025-q4',
    reviewDate: '2025-10-12',
    reviewerName: 'Christoph Both',
    reviewerRoleKey: 'biasReview.reviewerRole.cofounderLawyerDe',
    scopeKey:    'biasReview.q4_2025.scope',
    findingKeys: [
      'biasReview.q4_2025.finding1',
      'biasReview.q4_2025.finding2',
    ],
    actionsKey:  'biasReview.q4_2025.actions',
    nextReviewDue: '2026-01-15',
  },
];

/**
 * Convenience getter for the most recent review.
 */
export function getLatestBiasReview() {
  return BIAS_REVIEW_LOG[0] || null;
}
